import Vue from 'vue'
import Resource from 'vue-resource'
import validation from './validation'
import router from './router'
import store from './store'
import i18n from './i18n'
import App from './App'
import Auth from './plugins/ores-auth'
import filters from './filters'
import VueAppInsights from 'vue-application-insights'
import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false

// configure $http plugin
Vue.use(Resource)
Vue.http.options.root = process.env.VUE_APP_API_URL
Vue.http.interceptors.push(function (request) {
  request.headers.set('Accept-Language', Vue.i18n.locale())
})

// configure translations
i18n.configure(store)

// configure input custom validators
validation.configure(window.currentCulture)

// configure authentication
Vue.use(Auth, {
  store
})

Vue.use(VueAppInsights, {
  id: process.env.VUE_APP_AI_KEY,
  router
})

// configure custom filters
filters.configure(Vue)

Vue.use(VueScrollTo)

/* eslint-disable no-new */
let vueInstance = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

export let http = vueInstance.$http
